import { ServiceContext } from 'utilities/service.utils';

const LocateService = new ServiceContext(process.env.REACT_APP_BASE_URL, {
  withCredentials: true
});

export default LocateService;
